import HObject from '@/core/HObject.js'
import * as BABYLON from 'babylonjs'

export default class OfficeR05 extends HObject {
  static meshes = []
  static loadRequest = false
  constructor (hObject) {
    super(hObject.name, hObject.type, hObject.allowRegistration)
    this.init(hObject)
    this.inQueue = false
  }

  loadObject () {
    let hObject = this
    OfficeR05.loadRequest = true
    BABYLON.SceneLoader.LoadAssetContainerAsync('static/assets/OfficeR05/', 'oficina.babylon', window.scene).then(function (container) {
      for (let i = 0; i < container.meshes.length; i++) {
        container.meshes[i].isVisible = false
      }
      hObject.lod(container.meshes, 100)
      container.addAllToScene()

      OfficeR05.meshes = container.meshes
    })
  }

  register () {
    if (OfficeR05.meshes.length) { // Se puede registrar el objeto puesto que ya se pueden crear instancias
      // Se marca que ya queda registrado, para que en un siguiente registro no se registre mas de una vez
      this.registered = true

      let newInstances = []

      for (let i = 0; i < OfficeR05.meshes.length; i++) {
        newInstances.push(OfficeR05.meshes[i].createInstance(OfficeR05.meshes[i].name))
      }

      this.objectConfigurations(newInstances)

      this.setup()
    } else {
      if (OfficeR05.loadRequest === false) { // La primera vez que se desea registrar el objeto se debe cargar desde el servidor
        this.loadObject()
      }
      // Se agrega el objeto a la cola para reintentar posteriormente
      if (!this.inQueue) { // Se agrega sólo si aún no se ha agregado a la cola
        this.inQueue = true
        window.hScene.hObjectsRegisterQueue.push(this)
      }
    }
  }

  setup () {

  }
  openDoor1 () {

  }
  // activate_door () {
  //   console.log('...')
  // }
}



// WEBPACK FOOTER //
// ./src/hobjects/OfficeR05.js